// @flow @format
import React from 'react';
import Logo from '../../../../components/Logo';
import UserIcon from '../../../../components/Icon/user';
import PassIcon from '../../../../components/Icon/lock';
import LoadingIcon from '../../../../components/Icon/circle-o-notch';
import SuccessIcon from '../../../../components/Icon/check';
import ErrorIcon from '../../../../components/Icon/exclamation-circle';
import classNames from 'lib/classnames';
import './LoginForm.css';

type Props = {
	username: string,
	password: string,
	status: string,
	handleChange: (event: Event) => void,
	handleSubmit: (event: Event) => void,
};

function LoginForm({
	username,
	password,
	status,
	handleChange,
	handleSubmit,
}: Props) {
	return (
		<form
			name="login"
			className="LoginForm"
			onSubmit={handleSubmit}
			autoComplete="off"
		>
			<Logo theme="light" className="LoginForm__logo" />

			<InputGroup>
				<UserIcon className="LoginForm__inputGroup__icon" />
				<Input
					type="email"
					name="username"
					placeholder="Nombre de usuario"
					value={username}
					onChange={handleChange}
					disabled={status === 'loading'}
				/>
			</InputGroup>

			<InputGroup>
				<PassIcon className="LoginForm__inputGroup__icon" />
				<Input
					type="password"
					name="password"
					placeholder="Contraseña"
					value={password}
					onChange={handleChange}
					disabled={status === 'loading'}
				/>
			</InputGroup>

			<FormError visible={status === 'error'} />

			<FormControls>
				<ControlButton status={status} />
			</FormControls>
		</form>
	);
}

export default LoginForm;

const InputGroup = ({children}) =>
	<div className="LoginForm__inputGroup">{children}</div>;

const Input = props =>
	<input {...props} className="LoginForm__inputGroup__input" required />;

const FormControls = ({children}) =>
	<div className="LoginForm__controls">{children}</div>;

const FormError = ({visible}) =>
	<div className="LoginForm__error">
		{visible && 'Usuario o contraseña incorrectos.'}
	</div>;

const buttonIcons = {
	success: <SuccessIcon className="LoginForm__SuccessButton" />,
	loading: <LoadingIcon className="LoginForm__LoadingButton" />,
	error: <ErrorIcon className="LoginForm__ErrorButton" />,
	pristine: 'Ingresar',
};

const ControlButton = ({status}) =>
	<button
		className={classNames({
			LoginForm__controls__button: true,
			'LoginForm__controls__button--loading': status === 'loading',
			'LoginForm__controls__button--success': status === 'success',
			'LoginForm__controls__button--error': status === 'error',
		})}
		disabled={
			status === 'loading' || status === 'error' || status === 'success'
		}
		type="submit"
	>
		{buttonIcons[status]}
	</button>;



// WEBPACK FOOTER //
// ./src/routes/Login/components/LoginForm/LoginForm.js